import { companyRequest, type CompanyContext } from './api';
export type TeamRole = 'owner' | 'admin' | 'member';
export interface TeamPerson {
  userId: string;
  email: string;
  displayName: string | null;
  role: TeamRole;
  canPublish: boolean | null;
}
export interface TeamData {
  people: TeamPerson[];
  invitations: { id: string; email: string; role: TeamRole; expiresAt: string }[];
}
const base = '/api/v1/company';
export const fetchTeam = () => companyRequest<TeamData>(`${base}/team`);
export const changeMember = (person: TeamPerson) =>
  companyRequest<TeamData>(`${base}/team/${encodeURIComponent(person.userId)}`, 'PATCH', {
    role: person.role,
    canPublish: person.canPublish,
  });
export const removeMember = (userId: string) =>
  companyRequest<TeamData>(`${base}/team/${encodeURIComponent(userId)}`, 'DELETE', {});
export const transferOwnership = (userId: string) =>
  companyRequest<CompanyContext>(`${base}/ownership`, 'POST', { userId });
export const createTeamInvite = (body: {
  email: string;
  role: string;
  operationKey: string;
  expiresAt: string;
}) => companyRequest<{ id: string; url: string }>(`${base}/team/invitations`, 'POST', body);
export const revokeTeamInvite = (id: string) =>
  companyRequest<TeamData>(`${base}/team/invitations/${encodeURIComponent(id)}`, 'DELETE', {});
